import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import {Link} from "react-router-dom";
import {connect}  from  "react-redux";

class AdminInvoice extends Component{
    constructor(props) {
        super(props);
        this.state ={
            subMenuPermissions:[],
        }
    }
    componentWillMount() {
        this.props.currentMenu("unipaynext");
        }
    componentDidMount() {
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        let subMenuPermissions = [];
        let reportPermissions = [];
        AllAccessPermissions.map((permissionName, i) => {
            if(permissionName.access_type=='Submenu'){
                subMenuPermissions.push(permissionName.access_name);
            }

        });
        if(subMenuPermissions.includes("admin_invoice")===false){
            this.unauthorize_access();
        }
        this.setState({
            subMenuPermissions:subMenuPermissions,
            user_id:decoded._id
        });
    }
    unauthorize_access(){
        localStorage.removeItem("usertoken");
        localStorage.removeItem("userPermission");
        this.setState({
            loggedIn: false
        });
        alert("Unauthorized Access");
        window.location.href = "/";
    }

    render() {
        return(
          
            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 pt-5">
                            <div className="">
                                <div className="content">
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <div className="card title-card-bottom-space">
                                                <div className="header">
                                                    <h4 className="title">Invoice</h4>
                                                    <p className="category"></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="content">
                                    <div className="row">
                                        {/* {this.state.subMenuPermissions.includes("invoice_dashboard")===true?
                                            <div className="col-lg-3 col-xs-6">
                                                <div className="card">
                                                    <div className="content text-center">
                                                        <Link className=""   to="/admin/invoice-dashboard/">
                                                            <div className="report-thumbs-ico">
                                                                <div className="icon-big text-center folder-icon">
                                                                    <i className="fa fa-folder-o"></i>
                                                                </div>
                                                                <h5>Dashboard</h5>

                                                            </div>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div> : null } */}
                                        {this.state.subMenuPermissions.includes("pricing_rules")===true?
                                            <div className="col-lg-3 col-xs-6">
                                                <div className="card">
                                                    <div className="content text-center">
                                                        <Link className=""   to="/admin/pricing-rules/">
                                                            <div className="report-thumbs-ico">
                                                                <div className="icon-big text-center folder-icon">
                                                                    <i className="fa fa-folder-o"></i>
                                                                </div>
                                                                <h5>Pricing Rules</h5>
                                                                {/* <div className="inv-step-title">Step 1</div> */}
                                                                <p className="inv-step-content">
                                                                    Add, view, approve and delete Pricing rules
                                                                </p>
                                                                

                                                            </div>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div> : null }
                                        {this.state.subMenuPermissions.includes("invoice_transaction")===true?
                                            <div className="col-lg-3 col-xs-6">
                                                <div className="card">
                                                    <div className="content text-center">
                                                        <Link className="" to ="/admin/invoice-transaction/">
                                                            <div className="report-thumbs-ico">
                                                                <div className="icon-big text-center folder-icon">
                                                                    <i className="fa fa-folder-o"></i>
                                                                </div>
                                                                <h5>Invoice Details</h5>
                                                                {/* <div className="inv-step-title">Step 2</div> */}
                                                                <p className="inv-step-content">
                                                                    View and download invoice details
                                                                </p>
                                                            </div>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div> : null }
                                        <div className="col-lg-3 col-xs-6">
                                            <div className="card">
                                                <div className="content text-center">
                                                    <Link className=""   to="/admin/additional-data/">
                                                        <div className="report-thumbs-ico">
                                                            <div className="icon-big text-center folder-icon">
                                                                <i className="fa fa-folder-o"></i>
                                                            </div>
                                                            <h5>Additional Data</h5>
                                                            {/* <div className="inv-step-title">Step 3</div> */}
                                                            <p className="inv-step-content">
                                                                Upload additional data for invoicing
                                                            </p>
                                                          
                                                        </div>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                        {this.state.subMenuPermissions.includes("invoices_page")===true?
                                            <div className="col-lg-3 col-xs-6">
                                                <div className="card">
                                                    <div className="content text-center">
                                                        <Link className=""   to="/admin/invoices/">
                                                            <div className="report-thumbs-ico">
                                                                <div className="icon-big text-center folder-icon">
                                                                    <i className="fa fa-folder-o"></i>
                                                                </div>
                                                                <h5>Invoices</h5>
                                                                {/* <div className="inv-step-title">Step 4</div> */}
                                                                <p className="inv-step-content">
                                                                    Generate and download final invoice PDF
                                                                </p>
                                                              
                                                            </div>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div> : null }

                                            {this.state.subMenuPermissions.includes("invoice_process")===true?
                                            <div className="col-lg-3 col-xs-6">
                                                <div className="card">
                                                    <div className="content text-center">
                                                        <Link className=""   to="/admin/invoice-process/">
                                                            <div className="report-thumbs-ico">
                                                                <div className="icon-big text-center folder-icon">
                                                                    <i className="fa fa-folder-o"></i>
                                                                </div>

                                                                <h5>Invoice Process</h5>
                                                                 <p className="inv-step-content">
                                                                    Run Invoicing process, view and download invoice details
                                                                 </p>
                                                              
                                                            </div>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div> : null }

                                            <div className="col-lg-3 col-xs-6">
                                                <div className="card">
                                                    <div className="content text-center">
                                                        <Link className=""   to="/admin/monthwise-summary/">
                                                            <div className="report-thumbs-ico">
                                                                <div className="icon-big text-center folder-icon">
                                                                    <i className="fa fa-folder-o"></i>
                                                                </div>
                                                                <h5>Month Wise Summary</h5>
                                                                {/* <div className="inv-step-title">Step 3</div> */}
                                                                <p className="inv-step-content">
                                                                    &nbsp;
                                                                </p>
                                                                 <br/>

                                                            </div>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-lg-3 col-xs-6">
                                                <div className="card">
                                                    <div className="content text-center">
                                                        <Link className=""   to="/admin/active-utids/">
                                                            <div className="report-thumbs-ico">
                                                                <div className="icon-big text-center folder-icon">
                                                                    <i className="fa fa-folder-o"></i>
                                                                </div>
                                                                <h5>Active UTIDs</h5>
                                                                {/* <div className="inv-step-title">Step 3</div> */}
                                                                <p className="inv-step-content">
                                                                   &nbsp;
                                                                </p>
                                                                <br/>

                                                            </div>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
             );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
    currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
  }
  export default connect(null,mapDispatchToProps)( AdminInvoice );